import {
  FETCH_TEST_CONFIG,
  FETCH_TEST_CONFIG_START,
  FETCH_TEST_CONFIG_SUCCESS,
  FETCH_TEST_CONFIG_ERROR,
  FETCH_TEST_PROFILES,
  FETCH_TEST_PROFILES_START,
  FETCH_TEST_PROFILES_SUCCESS,
  FETCH_TEST_PROFILES_ERROR,
  POST_TEST_CONFIG,
  POST_TEST_CONFIG_START,
  POST_TEST_CONFIG_SUCCESS,
  POST_TEST_CONFIG_ERROR,
  UPDATE_TEST_CONFIG_NAMES,
  UPDATE_TEST_LIST,
  UPDATE_TEST_PROFILES,
  CLEAR_TEST_LIST,
  CLEAR_TEST_PROFILES,
  CLEAR_TEST_CONFIG_NAMES,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

/* Async Calls */
const clearTestList = () => ({ type: CLEAR_TEST_LIST })
const fetchTestConfig = (sku) => ({ type: FETCH_TEST_CONFIG, sku })
const fetchTestConfigStart = () => ({ type: FETCH_TEST_CONFIG_START })
const fetchTestConfigSuccess = () => ({ type: FETCH_TEST_CONFIG_SUCCESS })
const fetchTestConfigError = () => ({ type: FETCH_TEST_CONFIG_ERROR })
const startFetchTestConfigAsync = buildAsyncAction(
  FETCH_TEST_CONFIG,
  FETCH_TEST_CONFIG_START,
  [FETCH_TEST_CONFIG_SUCCESS, FETCH_TEST_CONFIG_ERROR]
)

const clearTestProfiles = () => ({ type: CLEAR_TEST_PROFILES })
const fetchTestProfiles = (details) => ({ type: FETCH_TEST_PROFILES, details })
const fetchTestProfilesStart = () => ({ type: FETCH_TEST_PROFILES_START })
const fetchTestProfilesSuccess = () => ({ type: FETCH_TEST_PROFILES_SUCCESS })
const fetchTestProfilesError = () => ({ type: FETCH_TEST_PROFILES_ERROR })
const startFetchTestProfilesAsync = buildAsyncAction(
  FETCH_TEST_PROFILES,
  FETCH_TEST_PROFILES_START,
  [FETCH_TEST_PROFILES_SUCCESS, FETCH_TEST_PROFILES_ERROR]
)

const postTestConfig = (details) => ({ type: POST_TEST_CONFIG, details })
const postTestConfigStart = () => ({ type: POST_TEST_CONFIG_START })
const postTestConfigSuccess = () => ({ type: POST_TEST_CONFIG_SUCCESS })
const postTestConfigError = () => ({ type: POST_TEST_CONFIG_ERROR })
const startPostTestConfigAsync = buildAsyncAction(
  POST_TEST_CONFIG,
  POST_TEST_CONFIG_START,
  [POST_TEST_CONFIG_SUCCESS, POST_TEST_CONFIG_ERROR]
)

const clearTestConfigNames = () => ({ type: CLEAR_TEST_CONFIG_NAMES })
const updateTestConfigNames = (configNames) => {
  return {
    type: UPDATE_TEST_CONFIG_NAMES,
    configNames
  }
}

const updateTestList = (tests) => {
  return {
    type: UPDATE_TEST_LIST,
    tests
  }
}

const updateTestProfiles = (testProfiles) => {
  return {
    type: UPDATE_TEST_PROFILES,
    testProfiles
  }
}

export {
  fetchTestConfig,
  fetchTestConfigStart,
  fetchTestConfigSuccess,
  fetchTestConfigError,
  startFetchTestConfigAsync,
  fetchTestProfiles,
  fetchTestProfilesStart,
  fetchTestProfilesSuccess,
  fetchTestProfilesError,
  startFetchTestProfilesAsync,
  postTestConfig,
  postTestConfigStart,
  postTestConfigSuccess,
  postTestConfigError,
  startPostTestConfigAsync,
  updateTestConfigNames,
  updateTestList,
  updateTestProfiles,
  clearTestList,
  clearTestProfiles,
  clearTestConfigNames,
}
